/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![BookmarkIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAwUlEQVR4nGNgGHYgNDSUzS8gvNPXP/yZX0DEf2Kwb0D4U7+AiA6QXoIWgBQSa7AfJu4gaAEpLvdDx/4Rz4nxwX9KMMOoBX6jQeQ3mopGdBD98wsInwTBIDZ1Lfjt6x+eDFPjGxAR4+sf/otaFnz194/0wlDnF+biGxDxiSILfP0j3voGhVnjUusTGGbq5x/xiiwLQLWUv3+ULiH1PkGRGn4BEQ9JsWCPn3/EKW/vUGmCiqEApNbXP/wkSC+xeoYOAABa/ilZ9kjonQAAAABJRU5ErkJggg==)
 */
export const BookmarkIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M4 5a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v16a1 1 0 0 1-1.67.74l-5.66-5.13a1 1 0 0 0-1.34 0l-5.66 5.13A1 1 0 0 1 4 20.99V5Z"
        className={colorClass}
      />
    </svg>
  );
};
